import React from 'react';
import UsTodKamgaranchiMahiti from './UsTodKamgaranchiMahiti.jsx';
import UsTodniKamgarStore from '../stores/UsTodniKamgarStore';
import CardDetail from './CardDetail';
var axios = require('axios');
var constants = require("../constants/constants")
var trstyle = {
    float: 'right',
    margin: '10px 10px 0px 0px'
}
export default class VehicleFillInfo_Show_Details extends React.Component {
    constructor(props) {
        super(props);
        let CompanyId = localStorage.getItem('CompanyId') || 1;
        this.state = {
            iskamgarDetails: false,
            isKamgarInfo: false,
            isEditAction: false,
            KamgarInformation: [],
            workerInfo: [],
            editKamgarData: null,
            CompanyId: CompanyId,
            fname: ''
        };
        this.getKamgarInfo = this.getKamgarInfo.bind(this);
    }

    GetKamgarInformation() {
        var user = JSON.parse(sessionStorage.getItem("User"));
        let currentComponent = this;
        axios.get(constants.config.HOST + constants.api.GET_KAMGAR_DETAILS, {
            params: { TransportersId: user.TransportersId, CompanyId: localStorage.getItem('CompanyId') || 1, YearId: user.TargetYearId, fname: '' }
        }).then(function (response) {
            currentComponent.setState({ workerInfo: response.data })
        }).catch(function (error) {
            console.log(error);
        });
    }

    getKamgarInfo() {
        this.GetKamgarInformation();
    }

    componentWillMount() {
        this.GetKamgarInformation();
        UsTodniKamgarStore.addListener('Kamgar', this.getKamgarInfo);
    }

    componentWillUnmount() {
        UsTodniKamgarStore.removeListener('Kamgar', this.getKamgarInfo)
    }
    //Button method
    kamgarDetails(e) {
        this.setState({
            iskamgarDetails: true
        });
        this.props.history.push('/UsTodKamgaranchiMahiti')
    }

    KamgarInfo(e) {
        this.setState({
            isKamgarInfo: true
        });
    }

    editkamgarInfo(e, editKamgarData) {
        e.preventDefault();
        this.setState({
            editKamgarData: editKamgarData
        });
    }

    handleInputChange(e) {
        e.preventDefault();
        var name = e.target.name;
        var state = this.state;
        state[name] = e.target.value;
        this.setState(state);
    }

    searchKamgarName(fname) {
        let currentComponent = this;
        var user = JSON.parse(sessionStorage.getItem("User"));
        axios.get(constants.config.HOST + constants.api.SEARCH_KAMGAR_NAME, {
            params: {
                TransportersId: user.TransportersId, CompanyId: localStorage.getItem('CompanyId') || 1, YearId: user.TargetYearId,
                fname: fname
            }
        })
            .then(function (response) {
                currentComponent.setState({ workerInfo: response.data })
            }).catch(function (error) {
                console.log(error);
            });
    }
    render() {
        return (
            <div className="pages">
                <div data-page="form" className="page no-toolbar no-navbar">
                    <div className="page-content">
                        <div className="navbarpages navbarpagesbg">
                            <div className="navbar_left">
                                <h2 style={{ 'margin-top': '10px' }} ><b style={{ 'padding-left': '100px' }}>वाहतुकदार</b></h2>
                            </div>
                            <div className="navbar_right">
                                <a href="/UserProfile" className="external"><img src="images/icons/white/user.png" alt="" title="" /></a>
                            </div>
                        </div>
                        <div id="pages_maincontent">
                            <h3 style={{ margin: '0px', padding: '0px 0px 0px 80px', color: '#0000FF' }} className="Page_title"><b >कामगारांची  माहिती </b></h3>
                            <button type="button" className="btn  btn-primary btn-flat " style={trstyle} style={{ margin: '5px 0px 5px 245px' }} onClick={(e) => this.kamgarDetails(e)}>माहिती भरा </button>
                            <div>
                                {this.state.iskamgarDetails ?
                                    <UsTodKamgaranchiMahiti isEditCall={false} /> :
                                    null
                                }
                            </div><br />
                            <div class="form_row">
                                <input type="text" class="form_input" style={{ 'margin-left': '100px', 'line-height': '25px' }} id="fname" name="fname" value={this.state.fname}
                                    onChange={(e) => this.handleInputChange(e)} placeholder="कामगाराचे  नाव शोधा.. " />

                                <button type="button" className="btn btn-info  " onClick={() => this.searchKamgarName(this.state.fname)}>शोधा </button>
                            </div><br /><br />
                            <div>
                                {
                                    (this.state.workerInfo !== null || this.state.workerInfo !== undefined) ?
                                        this.state.workerInfo.map(function (worker, index) {
                                            return (
                                                <CardDetail Values={worker} worker={true} mukadam={false} vehicle={false} />
                                            )
                                        })
                                        : ''
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/component/KamgarFillInfo_Show_Details.jsx